var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgEdit = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M18.5303301,1.46966991 L22.5303301,5.46966991 C22.8232233,5.76256313 22.8232233,6.23743687 22.5303301,6.53033009 L12.5303301,16.5303301 C12.3896778,16.6709824 12.1989124,16.75 12,16.75 L8,16.75 C7.58578644,16.75 7.25,16.4142136 7.25,16 L7.25,12 C7.25,11.8010876 7.32901763,11.6103222 7.46966991,11.4696699 L17.4696699,1.46966991 C17.7625631,1.1767767 18.2374369,1.1767767 18.5303301,1.46966991 Z M8.75,12.3106602 L8.75,15.25 L11.6893398,15.25 L20.9393398,6 L18,3.06066017 L8.75,12.3106602 Z M19.25,14.66 C19.25,14.2457864 19.5857864,13.91 20,13.91 C20.4142136,13.91 20.75,14.2457864 20.75,14.66 L20.75,20 C20.75,21.5187831 19.5187831,22.75 18,22.75 L4,22.75 C2.48121694,22.75 1.25,21.5187831 1.25,20 L1.25,6 C1.25,4.48121694 2.48121694,3.25 4,3.25 L9.34,3.25 C9.75421356,3.25 10.09,3.58578644 10.09,4 C10.09,4.41421356 9.75421356,4.75 9.34,4.75 L4,4.75 C3.30964406,4.75 2.75,5.30964406 2.75,6 L2.75,20 C2.75,20.6903559 3.30964406,21.25 4,21.25 L18,21.25 C18.6903559,21.25 19.25,20.6903559 19.25,20 L19.25,14.66 Z"
  }));
};
export default SvgEdit;